import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Row } from 'reactstrap'
import LoadingAbsolute from '../../LoadingAbsolute'
import HobiFlowerSvg from '../../../assets/icons/HobiFlowerSvg'
import success from '../../../assets/png/success.png'
import Header from '../../Header'

const HobiSuccessPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    console.log('state: ', state)

    setLoading(false)
  }, [state])

  return (
    <>
      {!state && loading ? (
        <LoadingAbsolute text={'Yükleniyor'} />
      ) : (
        <>
          {' '}
          <Header backButton={false} />
          <div style={{ with: '100%', fontWeight: '300' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '3rem 0 2rem 0',
              }}
            >
              <img src={success} width={175} alt='' />
            </div>

            <Row
              style={{
                display: 'flex',
                textAlign: 'center',
              }}
            >
              <p
                style={{
                  fontWeight: 400,
                  fontSize: 25,
                }}
              >
                Başvurunuz Tamamlandı
              </p>
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyItems: 'center',
                textAlign: 'center',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <p>
                Başvurunuz <b>{`#${state?.id}`}</b> numarası ile kayıt altına
                alınmıştır. 😊
              </p>
            </Row>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#285843',
              marginTop: '1rem',
            }}
          >
            <Button
              block
              style={{
                marginRight: '1rem',
                marginLeft: '1rem',
                backgroundColor: '#fff',
                borderRadius: '50px',
                borderColor: '#205c42',
                paddingTop: '.6rem',
                paddingBottom: '0.5rem',
                color: '#205c42',
              }}
              onClick={() => navigate('/hobiList')}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '.5rem',
                }}
              >
                <HobiFlowerSvg width={'1.1rem'} />
                <div style={{ paddingBottom: 4, fontWeight: '400' }}>
                  Başvurumu Görüntüle
                </div>
              </div>
            </Button>
          </div>
        </>
      )}
    </>
  )
}

export default HobiSuccessPage
